import React from 'react';
import { cm } from 'src/utils/classNames';
import { WithClassName } from 'src/utils/UtilityTypes';

export type SEMANTIC_STATUS = 'green' | 'amber' | 'red' | 'grey';

interface Props extends WithClassName {
	status: SEMANTIC_STATUS;
}

const SemanticChip = ({ status, className }: Props) => {
	return (
		<div
			className={cm(
				'block size-2 rounded-full',
				status === 'green'
					? 'bg-text-positive-green-button'
					: status === 'amber'
						? 'bg-text-star-yellow'
						: status === 'grey'
							? 'bg-text-secondary'
							: 'bg-text-negative-red-button',
				className
			)}
		/>
	);
};

export default SemanticChip;
